<template>
  <div>
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        รายงานการแก้ไขรายละเอียดของรายการส่งเสริมการขาย
        <small></small>
      </h1>
      <ol class="breadcrumb">
        <li>
          <a href="#">
            <i class="fa fa-dashboard"></i> รายงานการแก้ไขรายละเอียดของรายการส่งเสริมการขาย
          </a>
        </li>
      </ol>
    </section>

    <section class="content">
      <transition name="page" mode="out-in">
        <div class="row">
          <div class="col-xs-12">
            <div class="box box-primary">
              <div class="box-header">
                <div class="wrapper_history">
                  <h3 v-if="this.history.length > 0">ชื่อรายการส่งเสริมการขาย : {{ this.promotion_name }}</h3>
                  <h3 v-else>ไม่พบประวัติการแก้ไข</h3>
                  <el-collapse >
                    <el-collapse-item v-for="(item,index) in this.history" :key="index">
                      <template slot="title">
                        <div style="width:20%;">
                          <label for>{{ item.editor }}</label>
                        </div>
                        <div align="right" style="width:80%;">
                          <label for>วันที่และเวลา {{ item.created_at }}</label>
                        </div>
                      </template>
                      <el-table :data="item.row" style="width: 100%">
                        <el-table-column prop="colname" class="red" label="หัวข้อที่มีการแก้ไข"></el-table-column>
                        <el-table-column prop="old_data" label="ข้อมูลเดิมก่อนหน้า"></el-table-column>
                        <el-table-column prop="new_data" label="ข้อมูลที่แก้ไขใหม่"></el-table-column>
                      </el-table>
                    </el-collapse-item>
                  </el-collapse>
                  <el-button type="primary" style="margin-top: 20px" @click="goBack()">ย้อนกลับ</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </section>
    <!-- /.content -->
  </div>
</template>
<script>
import { mapState,mapActions } from "vuex"
export default {
  data() {
    return {
       historytable: ["1"],
      edithistory_table_1: [
        {
          edittypetable: "สิ้นสุดเสนอขาย",
          lastdata: "15/03/2019",
          newdata: "31/03/2019"
        },
        {
          edittypetable:
            "ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย ของผู้ให้บริการ",
          lastdata: "http://www.promotion.com/1234",
          newdata: "http://www.promotion.com/abc"
        }
      ],
      edithistory_table_2: [
        {
          edittypetable: "สิ้นสุดเสนอขาย",
          lastdata: "15/03/2019",
          newdata: "31/03/2019"
        },
        {
          edittypetable:
            "ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย ของผู้ให้บริการ",
          lastdata: "http://www.promotion.com/1234",
          newdata: "http://www.promotion.com/abc"
        }
      ],
      edithistory_table_3: [
        {
          edittypetable: "สิ้นสุดเสนอขาย",
          lastdata: "15/03/2019",
          newdata: "31/03/2019"
        },
        {
          edittypetable:
            "ลิงก์เว็บไซต์ หรือ ลิงก์รายการส่งเสริมการขาย ของผู้ให้บริการ",
          lastdata: "http://www.promotion.com/1234",
          newdata: "http://www.promotion.com/abc"
        }
      ],
      label_position: "top",
      form: {
        namePromotion: "",
        networkName: "",
        service_type: "",
        typeOfservice: "",
        dateRange: [new Date(), new Date()],
        Price_range: [0.32, 0.945]
      },
      tableProps: {
        border: true,
        stripe: true,
        defaultSort: {
          prop: "flow_no",
          order: "descending"
        }
      }
    };
  },
  computed: {
    ...mapState({
      history : store => store.Manage_internet.histories,
      promotion_name : store=>store.Manage_internet.name
    })
  },
  methods: {
    goBack(){
      var route = this.$router.currentRoute.path.includes('Operator') ? 'Operator_Manage_internet' : 'Manage_internet'
      this.$router.push({name : route})
    }
  }
};
</script>
<style >
.el-table__header tr th .cell{
  color:black;
}
</style>

